/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentTreeCreate = {
    properties: {
        startTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        twoMatchesAtATime: {
            type: 'boolean',
            isRequired: true,
        },
        pauseBetweenMatchesMinutes: {
            type: 'number',
            isRequired: true,
        },
        matchSectionDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        matchSectionPauseDurationMinutes: {
            type: 'number',
            isRequired: true,
        },
        isLosersBracket: {
            type: 'boolean',
            isRequired: true,
        },
        place3: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
